import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editProvider = ( {data, providerId} : {data: IPostEditProvider | {}, providerId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/Providers/UpdateProvider/${providerId}`, data);
};

type QueryFnType = typeof editProvider;

type UseEditProviderOptions = {
  data: IPostEditProvider | {};
  providerId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditProvider = ({ config }: UseEditProviderOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Παρόχου.`, 500);
            console.error('Couldnt edit Provider', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllProviders"])
            addNotification('Ο Πάροχος Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editProvider,
    })
}